export default __webpack_public_path__ + "static/media/poster(yourturn).685f9023.png";